import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './components/Login';
import AdminConsole from './components/AdminConsole';
import Home from './components/Home';
import Hrana from './components/Hrana';
import Trening from './components/Trening';
import Izvestaji from './components/Izvestaji';
import Profile from './components/Profile';
import Sabloni from './components/Sabloni';
import Navbar from './components/Navbar';
import Andrej from './components/Andrej';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';

const PUBLIC_PATHS = ['/andrej'];

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function NavbarGate() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated || PUBLIC_PATHS.includes(location.pathname)) return null;
  return <Navbar />;
}

function AppRoutes() {
  const { user, isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/andrej" element={<Andrej />} />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            {(user && (user.role === 'admin' || user.role === 'super_admin' || user.role === 'coach')) ? <AdminConsole /> : <Navigate to="/" />}
          </ProtectedRoute>
        } 
      />
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/hrana" element={<ProtectedRoute><Hrana /></ProtectedRoute>} />
      <Route path="/trening" element={<ProtectedRoute><Trening /></ProtectedRoute>} />
      <Route path="/izvestaji" element={<ProtectedRoute><Izvestaji /></ProtectedRoute>} />
      <Route path="/sabloni" element={<ProtectedRoute><Sabloni /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
      <Router>
        <div className="App">
          <NavbarGate />
          <AppRoutes />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;

